export default "__VITE_ASSET__DZzX9RU4__"